import { Outlet, useLocation } from 'react-router-dom';
import { Suspense, useState } from 'react';
import { AnimationCommon, LoadingFallback } from 'components/common';
import Navbar from './Navbar/index';
import { AnimatePresence } from 'framer-motion';
import Sidebar from './Sidebar/Sidebar';
import { useMediaQuery } from 'react-responsive';
const SettingLayout: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const params = new URLSearchParams(window.location.search);
  const isPreviewMode = params.get('preview') === 'true';
  const location = useLocation();
  const [collapsed, setCollapsed] = useState(false);
  const isDesktop = useMediaQuery({ minWidth: 1280 });
  return (
    <div className='flex flex-col min-h-screen'>
      {!isPreviewMode && <Navbar />}
      <div
        className={
          isPreviewMode
            ? 'flex flex-grow gap-4 p-8 bg-[var(--bgGreyColor3)] '
            : 'flex flex-grow gap-4 overflow-hidden p-4 bg-[var(--bgGreyColor2)] '
        }
      >
        {!isPreviewMode && <Sidebar collapsed={collapsed} setCollapsed={setCollapsed} />}
        <Suspense fallback={<LoadingFallback />}>
          <AnimatePresence mode='wait'>
            <AnimationCommon
              key={location.pathname}
              effect='pageTransition'
              transition='medium'
              duration={0.4}
              delay={0.2}
              role='main'
              disablePresence={true}
              className={'flex-grow ' + (isPreviewMode ? 'rounded-3xl' : 'rounded-lg')}
            >
              <Outlet />
              <div
                className={`${!isPreviewMode && (isDesktop ? '' : !collapsed ? 'max-w-[calc(100vw-288px)]' : 'max-w-[calc(100vw-128px)]')}`}
              >
                {children}
              </div>
            </AnimationCommon>
          </AnimatePresence>
        </Suspense>
      </div>
    </div>
  );
};

export { SettingLayout };
